import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // 10 minutes - longer stale time for better performance
      gcTime: 15 * 60 * 1000, // 15 minutes cache (gcTime is the new name for cacheTime in React Query v5)
      retry: 1,
      refetchOnWindowFocus: false, // Prevent unnecessary refetches
      refetchOnMount: false, // Use cache when possible
    },
    mutations: {
      retry: 0, // Don't retry failed mutations automatically
    }
  },
})